import Immutable from 'immutable';
import React, { ReactElement } from 'react';
import ConfirmUploadsListRow from './ConfirmUploadsListRow';

const ConfirmUploadsRenderer = (
  style: React.CSSProperties,
  index: number,
  data: {
    id: string;
    type: string;
    name: string;
  }[],
  selectedFiles: Immutable.Set<any>,
  handleItemSelected: (name: string, isChecked: boolean) => void
): ReactElement => {
  const file = data[index] || [
    {
      id: '',
      type: '',
      name: '',
    },
  ];

  return (
    <ConfirmUploadsListRow
      style={style}
      fileSelected={(name: string, isChecked: boolean) =>
        handleItemSelected(name, isChecked)
      }
      isChecked={selectedFiles.has(file.name)}
      key={file.id}
      id={file.id}
      name={file.name}
    />
  );
};

export default ConfirmUploadsRenderer;
